export default __webpack_public_path__ + "static/media/contact-us.213a2d0b.jpg";